import { NgModule } from '@angular/core';
import { AchievementMessagePipe } from './achievement-message.pipe';

@NgModule({
  declarations: [AchievementMessagePipe],
  exports: [AchievementMessagePipe]
})
export class AchievementMessagePipeModule {}
